import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.8889 13.679C13.4344 13.679 13.8765 13.2368 13.8765 12.6914C13.8765 12.1459 13.4344 11.7037 12.8889 11.7037C12.3434 11.7037 11.9012 12.1459 11.9012 12.6914C11.9012 13.2368 12.3434 13.679 12.8889 13.679Z"
          fill="#818C99"
        />
        <path
          d="M9.53087 17.2346C10.0763 17.2346 10.5185 16.7924 10.5185 16.2469C10.5185 15.7014 10.0763 15.2593 9.53087 15.2593C8.9854 15.2593 8.54321 15.7014 8.54321 16.2469C8.54321 16.7924 8.9854 17.2346 9.53087 17.2346Z"
          fill="#818C99"
        />
        <path
          d="M12.8889 17.2346C13.4344 17.2346 13.8765 16.7924 13.8765 16.2469C13.8765 15.7014 13.4344 15.2593 12.8889 15.2593C12.3434 15.2593 11.9012 15.7014 11.9012 16.2469C11.9012 16.7924 12.3434 17.2346 12.8889 17.2346Z"
          fill="#818C99"
        />
        <path
          d="M16.2469 13.679C16.7924 13.679 17.2346 13.2368 17.2346 12.6914C17.2346 12.1459 16.7924 11.7037 16.2469 11.7037C15.7014 11.7037 15.2593 12.1459 15.2593 12.6914C15.2593 13.2368 15.7014 13.679 16.2469 13.679Z"
          fill="#818C99"
        />
        <path
          d="M17.4321 5.77778H12.8182C12.9857 6.1523 13.1113 6.54894 13.1887 6.96296H17.4321C18.1946 6.96296 18.8148 7.58321 18.8148 8.34568V8.93827H13.1887C13.1109 9.3523 12.9853 9.74894 12.8182 10.1235H18.8148V17.4321C18.8148 18.1946 18.1946 18.8148 17.4321 18.8148H8.34568C7.58321 18.8148 6.96296 18.1946 6.96296 17.4321V13.1887C6.54894 13.1109 6.1523 12.9853 5.77778 12.8182V17.4321C5.77778 18.848 6.92978 20 8.34568 20H17.4321C18.848 20 20 18.848 20 17.4321V8.34568C20 6.92978 18.848 5.77778 17.4321 5.77778Z"
          fill="#818C99"
        />
        <path
          d="M7.95062 11.9012C10.1325 11.9012 11.9012 10.1325 11.9012 7.95062C11.9012 5.76875 10.1325 4 7.95062 4C5.76875 4 4 5.76875 4 7.95062C4 10.1325 5.76875 11.9012 7.95062 11.9012Z"
          stroke="#818C99"
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.95061 5.97531V7.95062L8.74074 8.74074"
          stroke="#818C99"
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
